module.exports = __webpack_public_path__ + "static/media/14_MBTA - Boston.7c626b5f.jpg";